/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as OrganisationsIndexRouteImport } from './routes/organisations/index'
import { Route as OrganisationsNewRouteImport } from './routes/organisations/new'
import { Route as OrganisationsIdRouteImport } from './routes/organisations/$id'
import { Route as AuthRegisterRouteImport } from './routes/auth/register'
import { Route as AuthPasswordSetupRouteImport } from './routes/auth/password-setup'
import { Route as AuthLoginRouteImport } from './routes/auth/login'

const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganisationsIndexRoute = OrganisationsIndexRouteImport.update({
  id: '/organisations/',
  path: '/organisations/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganisationsNewRoute = OrganisationsNewRouteImport.update({
  id: '/organisations/new',
  path: '/organisations/new',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganisationsIdRoute = OrganisationsIdRouteImport.update({
  id: '/organisations/$id',
  path: '/organisations/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthPasswordSetupRoute = AuthPasswordSetupRouteImport.update({
  id: '/password-setup',
  path: '/password-setup',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/auth': typeof AuthRouteRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/auth/password-setup': typeof AuthPasswordSetupRoute
  '/auth/register': typeof AuthRegisterRoute
  '/organisations/$id': typeof OrganisationsIdRoute
  '/organisations/new': typeof OrganisationsNewRoute
  '/organisations/': typeof OrganisationsIndexRoute
}
export interface FileRoutesByTo {
  '/auth': typeof AuthRouteRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/auth/password-setup': typeof AuthPasswordSetupRoute
  '/auth/register': typeof AuthRegisterRoute
  '/organisations/$id': typeof OrganisationsIdRoute
  '/organisations/new': typeof OrganisationsNewRoute
  '/organisations': typeof OrganisationsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/auth': typeof AuthRouteRouteWithChildren
  '/auth/login': typeof AuthLoginRoute
  '/auth/password-setup': typeof AuthPasswordSetupRoute
  '/auth/register': typeof AuthRegisterRoute
  '/organisations/$id': typeof OrganisationsIdRoute
  '/organisations/new': typeof OrganisationsNewRoute
  '/organisations/': typeof OrganisationsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/auth'
    | '/auth/login'
    | '/auth/password-setup'
    | '/auth/register'
    | '/organisations/$id'
    | '/organisations/new'
    | '/organisations/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth'
    | '/auth/login'
    | '/auth/password-setup'
    | '/auth/register'
    | '/organisations/$id'
    | '/organisations/new'
    | '/organisations'
  id:
    | '__root__'
    | '/auth'
    | '/auth/login'
    | '/auth/password-setup'
    | '/auth/register'
    | '/organisations/$id'
    | '/organisations/new'
    | '/organisations/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  OrganisationsIdRoute: typeof OrganisationsIdRoute
  OrganisationsNewRoute: typeof OrganisationsNewRoute
  OrganisationsIndexRoute: typeof OrganisationsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organisations/': {
      id: '/organisations/'
      path: '/organisations'
      fullPath: '/organisations/'
      preLoaderRoute: typeof OrganisationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organisations/new': {
      id: '/organisations/new'
      path: '/organisations/new'
      fullPath: '/organisations/new'
      preLoaderRoute: typeof OrganisationsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organisations/$id': {
      id: '/organisations/$id'
      path: '/organisations/$id'
      fullPath: '/organisations/$id'
      preLoaderRoute: typeof OrganisationsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/register': {
      id: '/auth/register'
      path: '/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/password-setup': {
      id: '/auth/password-setup'
      path: '/password-setup'
      fullPath: '/auth/password-setup'
      preLoaderRoute: typeof AuthPasswordSetupRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
  }
}

interface AuthRouteRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthPasswordSetupRoute: typeof AuthPasswordSetupRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthPasswordSetupRoute: AuthPasswordSetupRoute,
  AuthRegisterRoute: AuthRegisterRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthRouteRoute: AuthRouteRouteWithChildren,
  OrganisationsIdRoute: OrganisationsIdRoute,
  OrganisationsNewRoute: OrganisationsNewRoute,
  OrganisationsIndexRoute: OrganisationsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
